<div class="wrapper">
  @if (data.isJustActivated) {
    <h2>{{ 'pwa.list.modal.activated.title' | translate }}</h2>
  } @else {
    {{ 'pwa.list.modal.activated.profit-title' | translate }}
  }
  <div class="content">
    @if (data.isJustActivated) {
      <div class="d-flex flex-row align-items-center justify-content-center mb-4">
        <h2 class="my-0 py-0">{{ 'pwa.list.modal.activated.subtitle' | translate }}</h2>
        <app-icon [name]="'check-green'" [width]="'23px'" [height]="'23px'"></app-icon>
      </div>
    }
    <div>
      {{ 'pwa.list.modal.activated.content-1' | translate }}
    </div>
    <div class="url-data" (click)="copyLink()">
      {{ data.pwa.installUrl }}
    </div>
    <div>
      {{ 'pwa.list.modal.activated.content-2' | translate }}
    </div>
    <div>
      {{ 'pwa.list.modal.activated.content-3' | translate }}
    </div>
    <div class="divider"></div>
    <div>
      {{ 'pwa.list.modal.activated.content-4' | translate }}
    </div>

    <ul>
      <li>{{ 'pwa.list.modal.activated.content-5' | translate }}</li>
      <li>{{ 'pwa.list.modal.activated.content-6' | translate }}</li>
      <li>{{ 'pwa.list.modal.activated.content-7' | translate }}</li>
    </ul>

  </div>
  <div class="actions">
    <button class="btn btn-outline-primary" (click)="close()">
      {{ 'pwa.list.modal.activated.continue-btn' | translate }}
    </button>
  </div>
</div>
